import ImageWithBasePath from "@/components/image-with-base-path"
import type { LightboxSlide } from "@/components/common-lightbox/Lightbox"
import Lightbox from "@/components/common-lightbox/Lightbox"
import { useState, useEffect, useRef } from "react"
import { Link } from "react-router"

const AboutusSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const buttonTextRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (buttonTextRef.current) {
      const btn = buttonTextRef.current.closest('.animate-button2') as HTMLElement
      if (btn) {
        const text = btn.getAttribute("data-text") || ""
        const container = buttonTextRef.current

        container.innerHTML = ""

        const chars = text.split("")
        const total = chars.length
        const angle = 360 / total

        chars.forEach((char, i) => {
          const span = document.createElement("span")
          span.textContent = char
          span.style.setProperty("--index", i.toString())
          span.style.setProperty("--angle", angle.toString())
          container.appendChild(span)
        })
      }
    }
  }, [])

  const slides: LightboxSlide[] = [
    {
      type: "video",
      src: "https://www.youtube.com/embed/-FnrCZJw6TE",
      alt: "About Video",
    },
  ]

  return (
    <>
  {/* Start About Us Section */}
  <div className="section about-section-fifteen">
    <div className="container">
      {/* start about */}
      <div className="about-head wow fadeInUp" data-wow-duration="2s">
        <div className="row">
          <div className="col-xl-5 col-lg-4">
            <div className="section-header-fifteen">
              <div className="section-sub-title">About Us</div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-8">
            <div className="section-header-fifteen">
              <div className="section-title">
                With over a decade of experience, we've helped hundreds of
                individuals, couples, and families navigate life's challenges
                and achieve lasting positive change.
              </div>
            </div>
          </div>
        </div>
        <ImageWithBasePath
          src="assets/img/bg/about-img-two.png"
          alt="about"
          className="img-fluid element-1"
        />
      </div>
      {/* end about */}
      {/* Start About Video */}
      <div className="about-video-fifteen">
        <ImageWithBasePath
          src="assets/img/about/about-bg-img.jpg"
          alt="about"
          className="img-fluid img-1"
        />
        <div className="video-btn wow fadeInUp" data-aos-duration="2s">
          <Link
            to="#"
            data-fancybox=""
            onClick={() => {
              setCurrentIndex(0)
              setLightboxOpen(true)
            }}
          >
            <div
              className="animate-button2"
              data-text=" Play Video  · Play Video · "
            >
              <span className="button-text2" ref={buttonTextRef} />
              <span className="button-circle">
                <i className="isax isax-play" />
              </span>
            </div>
          </Link>
        </div>
        <div className="about-user wow fadeInUp" data-wow-duration="2s">
          <div className="avatar-list-stacked avatar-group-lg">
            <span className="avatar avatar-rounded">
              <ImageWithBasePath
                className="img-fluid"
                src="assets/img/users/user-sm-1.jpg"
                alt="img"
              />
            </span>
            <span className="avatar avatar-rounded">
              <ImageWithBasePath
                className="img-fluid"
                src="assets/img/users/user-sm-2.jpg"
                alt="img"
              />
            </span>
            <span className="avatar avatar-rounded">
              <ImageWithBasePath
                className="img-fluid"
                src="assets/img/users/user-sm-3.jpg"
                alt="img"
              />
            </span>
            <span className="avatar avatar-rounded">
              <ImageWithBasePath
                className="img-fluid"
                src="assets/img/users/user-sm-4.jpg"
                alt="img"
              />
            </span>
          </div>
          <p>
            More then 4.9K has <br /> been treated so far
          </p>
        </div>
      </div>
      {/* End About Video */}
    </div>
    <ImageWithBasePath
      src="assets/img/bg/line-bg.png"
      alt="line"
      className="img-fluid line-img"
    />
  </div>
  {/* End About Us Section */}
  <Lightbox
    images={slides}
    currentIndex={currentIndex}
    isOpen={lightboxOpen}
    onClose={() => setLightboxOpen(false)}
    onNavigate={(index) => setCurrentIndex(index)}
  />
</>

  )
}

export default AboutusSection